import React, {useContext, useEffect, useState} from "react";
import leftArrow from "../Assets/Images/left-arrow.svg";
import rightArrow from "../Assets/Images/right-arrow.svg";
import {DataContext} from "../Context/DataContext";
import buildPages from "../Services/Utils/buildPages";

export default function ComparativeTable({countryName, countryVariables, colombiaVariables}) {
	// Build variable pages
	const numberOfPages = Math.ceil(countryVariables.length / 6);
	const [pages, setPages] = useState(buildPages(countryVariables, numberOfPages));

	// Provides styling to country tabs
	const [showColombia, setShowColombia] = useState(false);
	const [tabsColor, setTabsColor] = useState("var(--blue-75)");

	const selectedStyles = {
		backgroundColor: "var(--gray-0)",
		color: "var(--blue)",
	};

	const noSelectedStyles = {
		backgroundColor: "transparent",
		color: "var(--white)",
	};

	const changeTabsColor = (hoverSide, isHoverOn) => {
		if (isHoverOn) {
			if ((hoverSide === "left" && showColombia) || (hoverSide === "right" && !showColombia)) setTabsColor("var(--blue)");
		} else {
			setTabsColor("var(--blue-75)");
		}
	};

	// Set the width of the variable table
	const {widthRef, tableWidth, setTableWidth} = useContext(DataContext);
	useEffect(() => {
		setTableWidth(widthRef.current.clientWidth);
	});

	// Change pages content by country
	const setCountry = (country) => {
		setShowColombia(country === "Colombia");
		if (country === "Colombia") setPages(buildPages(colombiaVariables, numberOfPages));
		else setPages(buildPages(countryVariables, numberOfPages));
	};

	// Change the page with the arrow buttons
	const [shownPage, setShownPage] = useState(0);
	const [movePX, setMovePX] = useState(0);

	const goToPage = (direction) => {
		let leftPX = [0],
			newShownPage = shownPage;

		for (let i = 0; i < numberOfPages; i++) leftPX.push(-tableWidth * (i + 1));

		if (direction === "left") {
			if (shownPage - 1 < 0) newShownPage = numberOfPages - 1;
			else newShownPage = shownPage - 1;
		} else newShownPage = (shownPage + 1) % numberOfPages;

		setShownPage(newShownPage);
		setMovePX(leftPX[newShownPage]);
	};

	// Builds the bars that show which page you are on
	let pagesBars = [];
	for (let i = 0; i < numberOfPages; i++) {
		pagesBars.push(<div style={{backgroundColor: shownPage === i ? "var(--blue)" : "var(--blue-50)"}}></div>);
	}

	return (
		<div className='comparative-table'>
			<div className='countries-tabs' style={{backgroundColor: tabsColor}}>
				<button style={showColombia ? noSelectedStyles : selectedStyles} onClick={() => setCountry("X")} onMouseEnter={() => changeTabsColor("left", true)} onMouseLeave={() => changeTabsColor("left", false)}>
					<p style={{borderColor: showColombia ? "transparent" : "var(--blue)"}}>{countryName}</p>
				</button>
				<button style={showColombia ? selectedStyles : noSelectedStyles} onClick={() => setCountry("Colombia")} onMouseEnter={() => changeTabsColor("right", true)} onMouseLeave={() => changeTabsColor("right", false)}>
					<p style={{borderColor: showColombia ? "var(--blue)" : "transparent"}}>Colombia</p>
				</button>
			</div>
			<div className='table-container' ref={widthRef}>
				<div className='table-list' style={{gridTemplateColumns: `repeat(${numberOfPages}, ${tableWidth}px)`, left: `${movePX}px`}}>
					{pages.map((page) => (
						<div>{page}</div>
					))}
				</div>
			</div>
			{numberOfPages > 1 && <div className='table-navigation'>
				<img src={leftArrow} alt='Ver anterior' onClick={() => goToPage("left")}></img>
				<div className='table-pages-bars' style={{gridTemplateColumns: `repeat(${numberOfPages}, 1fr)`}}>
					{pagesBars}
				</div>
				<img src={rightArrow} alt='Ver siguiente' onClick={() => goToPage("right")}></img>
			</div>}
		</div>
	);
}
